import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconOmega: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="omega, special-character"><path d="M3.75 19.25V21.25H9.9375V17.8896C6.66721 16.99 4.26562 14.0037 4.26562 10.4583C4.26562 6.20114 7.72842 2.75 12 2.75C16.2716 2.75 19.7344 6.20114 19.7344 10.4583C19.7344 14.0037 17.3328 16.99 14.0625 17.8896L14.0625 21.25H20.25V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconOmega;
